import { AlertTriangle, Link2 } from "lucide-react";

export const STATUS_CLASS = {
  Open: "status-neutral",
  "In Progress": "status-pending",
  Blocked: "status-inactive",
  "Done – Pending Verification": "status-review",
  Verified: "status-active",
  "Auto-closed": "status-neutral",
};

export const PRIORITY_CLASS = { High: "task-priority-high", Normal: "task-priority-normal", Low: "task-priority-low" };

export const fmtDay = (value) => (value ? new Date(`${value.slice(0, 10)}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");

export const TaskCard = ({ task, onOpen, compact = false }) => (
  <button
    type="button"
    className={`task-card ${task.overdue ? "task-card-overdue" : ""} ${compact ? "task-card-compact" : ""}`}
    data-testid={`task-card-${task.id}`}
    onClick={() => onOpen(task)}
  >
    <div className="task-card-top">
      <em className={`task-priority ${PRIORITY_CLASS[task.priority] || ""}`} data-testid={`task-priority-${task.id}`}>{task.priority}</em>
      <span className={`status-chip ${STATUS_CLASS[task.status] || ""}`} data-testid={`task-status-${task.id}`}>{task.status}</span>
    </div>
    <strong data-testid={`task-title-${task.id}`}>{task.title}</strong>
    <small>
      {task.owner_name} · due {fmtDay(task.due_date)}{task.due_time ? ` ${task.due_time} ET` : ""}
      {task.overdue && <span className="task-overdue-flag" data-testid={`task-overdue-${task.id}`}><AlertTriangle size={11} /> overdue</span>}
    </small>
    {!compact && task.linked && <small className="task-linked"><Link2 size={11} /> {task.linked.label}</small>}
    {task.source !== "manual" && <small className="task-source">{task.source === "system" ? "System-generated" : "Recurring"}</small>}
  </button>
);
